module.exports = __webpack_public_path__ + "static/media/feed.7cc15c2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/feed.png
// module id = 38
// module chunks = 0